import publicPage from './publicpage'
import testPage from './testpage'
import privatePage from './privatepage'
import pdfReport from './pdfReport'

export default {
  publicPage,
  testPage,
  privatePage,
  pdfReport,
  lang: 'Språk',
  sv: 'Svenska',
  en: 'English',
  de: 'Deutsch',
  it: 'Italian',
  yes: 'Ja',
  no: 'Nej',
  name: 'Namn',
  last_name: 'Efternamn',
  first_name: 'Förnamn',
  email_pin: 'E-post / PIN',
  customer_tag: 'Tag',
  method: 'Metod',
  end_date: 'Slutdatum',
  change_end_date: 'Ändra slutdatum',
  finished_date: 'Avslutat',
  test_not_started: 'Ej påbörjat',
  test_started: 'Påbörjat',
  test_finished: 'Avslutat',
  report: 'Rapport',
  create_report: 'Skapa profil',
  create_teamprofile: 'Skapa teamprofil',
  create_teamreport: 'Skapa teamrapport',
  team_name: 'Team-namn',
  report_type: 'Typ av rapport',
  report_cost: 'Kreditkostnad',
  report_unsupported_testmethod: 'Testmetod stöds ej ännu',
  norm_group: 'Normgrupp',
  name_required_feedback: 'Skriv ett namn!',
  field_required_feedback: 'Obligatoriskt fält.',
  participant: 'Deltagare',
  test: 'Tester',
  available_credits: 'Tillgängliga krediter',
  save: 'Spara',
  preview: 'Förhandsgranska',
  save_randomize: 'Spara & slumpgenerera',
  save_ok_feedback: 'Informationen har sparats',
  delete: 'Ta bort',
  reset: 'Återställ',
  cancel: 'Avbryt',
  update: 'Uppdatera',
  logo: 'Logo',
  questions: 'Frågor',
  question: 'Fråga',
  questionalternative: 'Svarsalternativ',
  errorMessage_server: 'Ett fel har uppstått',
  example: 'Exempel',
  pageNotFoundMessage: 'Hittade inte sidan!',
  folder: 'Mapp',
  image: 'Bild',
  numeric: 'Nummer',
  swedish: 'Svenska',
  english: 'English',
  deutsch: 'Deutsch',
  select_a_language: 'Välj ett språk',
  select_a_normgroup: 'Välj en normgrupp',
  select_a_report: 'Välj en rapport',
  clear: 'Rensa filter',
  type_to_search: 'Skriv för att söka',
  content: 'Innehåll',
  search: 'Sök',
  from: 'Från',
  to: 'Till',
  amount: 'Summa',
  date: 'Datum',
  result: 'Resultat',
  header: 'Rubrik',
  description: 'Beskrivning',
  text: 'Text',
  expert_report: 'Rapporter',
  create_expert_report: 'Skapa rapport',
  team_report: 'Teamprofil',
  prevPage: 'Föregående sida',
  nextPage: 'Nästa sida'
}
